import { render, staticRenderFns } from "./pvList.vue?vue&type=template&id=01c64d8c&scoped=true"
import script from "./pvList.vue?vue&type=script&lang=js"
export * from "./pvList.vue?vue&type=script&lang=js"
import style0 from "./pvList.vue?vue&type=style&index=0&id=01c64d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c64d8c",
  null
  
)

export default component.exports